jQuery (function () {
  var currentCatalogScreen,
    currentCatalogSelection,
    searchQueryTerm,
    selectedItems = new Array (),
    allCollections = new Array (),
    savedItemsForGeneration = {}
    editModeCatalogName=false,
    STICKERPACK_APP_BUCKET='https://stickerpack-storage.sfo3.digitaloceanspaces.com';


    /**
   * Disables next button
   */
  function disableNext () {
    jQuery ('.catalog-next').css ({
      background: '#b3b3b3',
      cursor: 'normal',
    });
    jQuery ('.catalog-next').off ('click');
  }

  /**
   * Enables next button
   */
  function enableNext (position) {
    jQuery ('.catalog-next').css ({
      background: 'var(--color-primary-blue)',
      cursor: 'pointer',
    });
    if (position === 'select-screen') {
      jQuery ('.catalog-next').parent ().addClass ('adjustNextButton');
    } else {
      jQuery ('.catalog-next').parent ().removeClass ('adjustNextButton');
    }
    jQuery ('.catalog-next').on ('click', handleNextClick);
  }

  /**
   * When catalog button is click on nav.
   */
  jQuery (
    '#download-catalog, a[href="/?action=generate_catalog"]'
  ).click (function (event) {
    event.preventDefault ();
    //window.history.replaceState({}, document.title, "/");
    jQuery ('#main-catalog-wrapper').css ({display: 'block'});
    jQuery ('.catalog-next').parent ().addClass ('adjustNextButton');
    jQuery ('#mm-blocker').trigger ('mousedown');
    setTimeout (function () {
      jQuery ('#main-catalog-wrapper').css ({opacity: '1'});
    }, 50);
    currentCatalogScreen = jQuery ('.select-catalog');
    jQuery ('html').css ({overflow: 'hidden'});
  });

  /**
   * When a catalog option is selected
   */
  jQuery ('.single-option').click (function (event) {
    event.stopPropagation ();
    if (currentCatalogSelection) {
      currentCatalogSelection.css ('background', 'none');
    }

    jQuery (this).css ({background: '#3eadef4d'});
    currentCatalogSelection = jQuery (this);

    enableNext ('select-screen');
  });

  /**
   * When a users click anywhere on window while on catalog screen.
   */
  jQuery (window).click (function () {
    if (
      currentCatalogScreen &&
      currentCatalogScreen.attr ('data-screen') === 'select'
    ) {
      jQuery ('.single-option').css ('background', 'none');
      currentCatalogSelection = null;
      disableNext ();
    }
    jQuery ('.sort-catalog .dropdown-container').css ('opacity', '0');
    setTimeout (function () {
      jQuery ('.sort-catalog .dropdown-container').css ('display', 'none');
    }, 300);
  });

  /**
   * When user closes the window.
   */
  jQuery ('.close-catalog .icon-close').click (function () {
    editModeCatalogName=false;

    jQuery ('#main-catalog-wrapper').css ({opacity: '0'});

    setTimeout (function () {
      jQuery ('#main-catalog-wrapper').css ({display: 'none'});
      jQuery ('.select-catalog').css ('display', 'block');
      jQuery ('.search-catalog').css ('display', 'none');
      jQuery ('.generate-catalog').css ('display', 'none');
      jQuery ('.collection-catalog').css ('display', 'none');

      jQuery ('.catalog-next').css ('display', 'block');
      jQuery ('.sort-catalog img').css ('display', 'none');
      jQuery ('.ct-download').css ('display', 'none');
      jQuery ('.ct-upload').css ('display', 'none');
      jQuery ('.catalog-back').css ('visibility', 'hidden');
      jQuery ('.catalog-navigator').css ({'margin-top': '70px'});
    }, 500);

    hideCtLoadingScreen ();

    currentCatalogSelection = null;
    selectedItems = new Array ();
    jQuery ('html').css ({overflow: 'auto'});
    disableNext ();
    jQuery ('.collection-multiple-select').select2 ('val', ' ');
    jQuery ('.predictive-search-select').val ('');
    jQuery ('.ct-products').remove ();
    jQuery ('.ct-footer-img').before (
      '<div class="ct-products" data-page="0"></div>'
    );
    jQuery ('.ct-n-page').remove ();

    jQuery ('.enter-ct-name').val ('CATALOG NAME').trigger('input');

    currentCatalogScreen = null;
  });

  /**
   * On next click
   */
  function handleNextClick () {
    event.stopPropagation ();
    if (currentCatalogScreen) {
      changeToNextScreen ();
    }
    return;
  }

  jQuery ('#regenerate-collections-catalog').click (function () {
    jQuery ('.ct-products').remove ();
    jQuery ('.ct-footer-img').before (
      '<div class="ct-products" data-page="0"></div>'
    );
    jQuery ('.ct-n-page').remove ();
    generateCatalogForCollections ();
    showCtLoadingScreen ();
  });

  jQuery ('#regenerate-search-catalog').click (function () {
    jQuery ('.ct-products').remove ();
    jQuery ('.ct-footer-img').before (
      '<div class="ct-products" data-page="0"></div>'
    );
    jQuery ('.ct-n-page').remove ();
    getSearchResults ();
    showCtLoadingScreen ();
  });
  /**
   * On Back click
   */
  function handleBackClick () {
    event.stopPropagation ();
    if (currentCatalogScreen.attr ('data-screen') !== 'select') {
      changeToPreviousScreen ();
    }
    return;
  }

  jQuery ('.catalog-back').on ('click', handleBackClick);

  /**
   * Switch to next screen
   */
  function changeToNextScreen () {
    if (
      currentCatalogScreen.attr ('data-screen') === 'search' ||
      (currentCatalogScreen.attr ('data-screen') === 'collection' &&
        selectedItems.length > 0)
    ) {
      jQuery ('.catalog-back').css ({visibility: 'visible'});
      jQuery ('.catalog-next').css ('display', 'none');

      //currentCatalogScreen.css("display", "none");

      if (currentCatalogScreen.attr ('data-screen') === 'search') {
        jQuery ('.predictive-search').addClass ('input-box-download-page');
        getSearchResults ();
      } else if (currentCatalogScreen.attr ('data-screen') === 'collection') {
        jQuery ('.collection-select').addClass ('input-box-download-page');
        generateCatalogForCollections ();
      }
      currentCatalogScreen = jQuery ('.generate-catalog ');
      showCtLoadingScreen ();
      return;
    }

    currentCatalogScreen.addClass ('shiftItemLeft');
    setTimeout (function () {
      currentCatalogScreen.removeClass ('shiftItemLeft');

      currentCatalogScreen.css ('display', 'none');
      if (currentCatalogScreen.attr ('data-screen') === 'select') {
        selectedItems = new Array ();
        jQuery ('.collection-multiple-select').select2 ('val', ' ');
        disableNext ();

        jQuery ('.catalog-back').css ({visibility: 'visible'});

        if (currentCatalogSelection.attr ('data-option') === 'search') {
          currentCatalogScreen = jQuery ('.search-catalog ');
          enableNext ();
        } else if (
          currentCatalogSelection.attr ('data-option') === 'collection'
        ) {
          currentCatalogScreen = jQuery ('.collection-catalog ');
        } else if (currentCatalogSelection.attr ('data-option') === 'cart') {
          jQuery ('.catalog-next').css ('display', 'none');
          currentCatalogScreen = jQuery ('.generate-catalog ');
          showCtLoadingScreen ();

          jQuery.getJSON ('/cart.json?limit=100').then (response => {
            selectedItems = response.items.map (item => {
              savedItemsForGeneration[item.key] = item;
              return item.key;
            });
            generateCatalogForSearchCart ();
            currentCatalogScreen.css ({display: 'block'});
          });
          return;
        }
      }
      currentCatalogScreen.css ({display: 'block'});
      currentCatalogScreen.addClass ('shiftItemCenter');
      setTimeout (function () {
        currentCatalogScreen.removeClass ('shiftItemCenter');
      }, 250);
    }, 250);
  }

  /**
   * Switch to next screen
   */
  function changeToPreviousScreen () {
    currentCatalogScreen.addClass ('.shiftItemRight');
    setTimeout (function () {
      currentCatalogScreen.removeClass ('.shiftItemRight');

      currentCatalogScreen.css ('display', 'none');
      if (
        currentCatalogScreen.attr ('data-screen') === 'search' ||
        currentCatalogScreen.attr ('data-screen') === 'collection'
      ) {
        jQuery ('.predictive-search-select').val ('');

        jQuery ('.catalog-back').css ('visibility', 'hidden');
        enableNext ('select-screen');
        currentCatalogScreen = jQuery ('.select-catalog');
      } else if (currentCatalogScreen.attr ('data-screen') === 'generate') {
        currentCatalogScreen.css ({opacity: '0'});

        jQuery ('.ct-products').remove ();
        jQuery ('.ct-footer-img').before (
          '<div class="ct-products" data-page="0"></div>'
        );
        jQuery ('.ct-n-page').remove ();
        jQuery ('.ct-download').css ('display', 'none');

        jQuery ('.collection-select').removeClass ('input-box-download-page');

        jQuery ('.sort-catalog img').css ('display', 'none');
        jQuery ('.catalog-next').css ('display', 'block');
        if (currentCatalogSelection.attr ('data-option') === 'cart') {
          currentCatalogScreen = jQuery ('.select-catalog');
          enableNext ('select-screen');
        } else {
          enableNext ();

          currentCatalogScreen = jQuery (
            "[data-screen='" +
              currentCatalogSelection.attr ('data-option') +
              "'"
          );
        }
      }
      currentCatalogScreen.css ({display: 'block'});
      currentCatalogScreen.addClass ('shiftItemLeftCenter');
      setTimeout (function () {
        currentCatalogScreen.removeClass ('shiftItemLeftCenter');
      }, 250);
    }, 250);
  }

  function showCtLoadingScreen (message = 'Generating Preview...') {
    jQuery ('.loading-screen').css ({display: 'flex'});
    jQuery ('.ct-loader h3').html (message);
    setTimeout (function () {
      jQuery ('.loading-screen').css ({opacity: '1'});
    }, 50);
  }

  function hideCtLoadingScreen () {
    jQuery ('.loading-screen').css ({opacity: '0'});
    setTimeout (function () {
      jQuery ('.loading-screen').css ({display: 'none'});
    }, 50);
  }

  function productFormatSelection (product) {
    return product.title;
  }

  function getCollections () {
    var collectionCount = window.collectionCount;
    var page = 1;
    var limit = 100;
    var pagesFetched = 0;
    while (collectionCount >= 0) {
      jQuery
        .getJSON ('/collections.json?limit=' + limit + '&page=' + page)
        .then (response => {
          allCollections = [...allCollections, ...response.collections];
          pagesFetched++;
          if (pagesFetched >= Math.ceil (collectionCount / limit)) {
            var mappedCollections = allCollections.map (collection => {
              collection.text = collection.title;
              collection.id = collection.handle;

              return collection;
            });
            jQuery ('.collection-multiple-select').select2 ({
              placeholder: 'Enter collection name',
              templateSelection: productFormatSelection,
              templateResult: collectionFormatResult,
              data: mappedCollections,
              multiple: true,
            });
          }
        });
      collectionCount = collectionCount - limit;
      page++;
    }
  }
  getCollections ();

  function collectionFormatResult (collection) {
    if (collection && collection.title && collection.image) {
      var html =
        "<table cellspacing='0' cellpadding='0' class='collection-results'><tr>";

      var imgUrlArr = collection.image.src.split ('?');

      var imgUrl =
        imgUrlArr[0].slice (0, -4) +
        '_120x' +
        imgUrlArr[0].slice (-4) +
        (imgUrlArr[1] ? '?' + imgUrlArr[1] : '');
      html += "<td class='product-image'><img src='" + imgUrl + "'/></td>";

      html += "<td class='product-info'>";
      html += collection.title + '<br />';
      html += '</td></tr></table><hr/>';
      return jQuery (html);
    }
    return '';
  }

  jQuery (
    '.collection-multiple-select'
  ).on ('select2:select select2:unselect', function () {
    selectedItems = jQuery (this).val ();

    if (selectedItems && selectedItems.length > 0) {
      //Ensure the navigator and select2 dont overlap.

      enableNext ();
    } else {
      disableNext ();
    }
  });

  function getSearchResults () {
    var search = jQuery ('.predictive-search-select').val ();
    searchQueryTerm = search;
    var searchArr = search.split (',');
    searchArr = searchArr.map (search => search.trim ());
    var searchTermIdx = 0;
    var itemsReceived = 0;
    var page = 1;
    selectedItems = new Array ();
    function ajaxSearch () {
      jQuery
        .getJSON (
          '/search.json?options%5Bprefix%5D=last&page=' +
            page +
            '&q=' +
            searchArr[searchTermIdx]
        )
        .then (response => {
          itemsReceived += response.results.length;
          var handles = response.results.map (item => {
            try {
              item.image = item.image[0] ? item.image[0] : item.image;
            } catch (err) {
              return false;
            }
            savedItemsForGeneration[item.handle] = item;
            return item.handle;
          });
          selectedItems = [...selectedItems, ...handles];

          if (response.results_count > itemsReceived) {
            showCtLoadingScreen (
              'Items Fetched (' +
                itemsReceived +
                '/' +
                response.results_count +
                ')' +
                (response.results_count > 2500
                  ? '<br><small style="font-size:16px;text-transform:none;">That\'s too many requests, link might get disabled for your IP!</small>'
                  : '<br><small style="font-size:16px;text-transform:none;">Fetching results for search term ' +
                      (searchTermIdx + 1) +
                      '.</small>')
            );
            page++;

            ajaxSearch ();
          } else if (searchTermIdx < searchArr.length) {
            page = 1;
            itemsReceived = 0;
            searchTermIdx++;
            ajaxSearch ();
          } else {
            selectedItems = selectedItems.filter (
              item => (item ? true : false)
            );
            generateCatalogForSearchCart ();
          }
        });
    }
    ajaxSearch ();
  }

  //Generate pagination for catalog.
  function generatePagination (switchToPage = null) {
    var paginationDisplay = screen.width >= 992 ? 10 : 8;
    paginationDisplay = screen.width >= 768 ? paginationDisplay : 5;

    jQuery ('.ct-products').each (function () {
      let dataIndex = parseInt (jQuery (this).attr ('data-page'));
      let pagination = jQuery (
        '<a class="ct-n-page ' +
          (dataIndex === 0 ? 'ct-current' : '') +
          '" data-index="' +
          dataIndex +
          '">' +
          (dataIndex + 1) +
          '</a>'
      );
      if (dataIndex > paginationDisplay - 1) {
        pagination.css ('display', 'none');
      }
      jQuery ('.ct-next-page').before (pagination);
    });

    var currentPage = 0;

    jQuery ('.ct-n-page').click (function () {
      jQuery ('.ct-n-page').removeClass ('ct-current');
      jQuery (this).addClass ('ct-current');
      let dataIndex = jQuery (this).attr ('data-index');
      let targetPage = jQuery ("[data-page='" + dataIndex + "']");
      let lastPage = jQuery ("[data-page='" + currentPage + "']");
      dataIndex = parseInt (dataIndex);
      if (currentPage < dataIndex) {
        lastPage.addClass ('shiftItemLeft');
        setTimeout (function () {
          lastPage.removeClass ('shiftItemLeft').css ('display', 'none');
          targetPage.addClass ('shiftItemCenter');
          setTimeout (function () {
            targetPage.removeClass ('shiftItemCenter').css ('display', 'block');
          }, 250);
        }, 250);
      } else if (currentPage > dataIndex) {
        lastPage.addClass ('shiftItemRight');
        setTimeout (function () {
          lastPage.removeClass ('shiftItemRight').css ('display', 'none');
          targetPage.addClass ('shiftItemLeftCenter');
          setTimeout (function () {
            targetPage
              .removeClass ('shiftItemLeftCenter')
              .css ('display', 'block');
          }, 250);
        }, 250);
      }
      if (dataIndex >= paginationDisplay - 1) {
        jQuery ('.ct-n-page').each (function () {
          let idx = parseInt (jQuery (this).attr ('data-index'));
          if (idx <= dataIndex - paginationDisplay - 1 || idx > dataIndex + 1) {
            jQuery ("[data-index='" + idx + "']").css ('display', 'none');
          } else {
            jQuery ("[data-index='" + idx + "']").css (
              'display',
              'inline-block'
            );
          }
        });
      } else {
        jQuery ('.ct-n-page').each (function () {
          let idx = parseInt (jQuery (this).attr ('data-index'));
          if (idx <= paginationDisplay - 1) {
            jQuery ("[data-index='" + idx + "']").css (
              'display',
              'inline-block'
            );
          } else {
            jQuery ("[data-index='" + idx + "']").css ('display', 'none');
          }
        });
      }
      currentPage = dataIndex;
    });
    jQuery ('.ct-prev-page').off ();
    jQuery ('.ct-prev-page').on ('click', function () {
      var prev = jQuery ('.ct-current:not(a:nth-child(2))').prev ();
      if (prev.length) {
        prev.trigger ('click');
      }
    });
    jQuery ('.ct-next-page').off ();

    jQuery ('.ct-next-page').on ('click', function (evt) {
      var next = jQuery ('.ct-current:not(a:nth-last-child(2))').next ();
      if (next.length) {
        next.trigger ('click');
      }
    });

    if (switchToPage !== null) {
      let page = jQuery (".ct-n-page[data-index='" + switchToPage + "']");

      if (page.length > 0) {
        jQuery ('.ct-n-page').removeClass ('ct-current');
        page.addClass ('ct-current');
        jQuery (".ct-products:not([data-page='" + switchToPage + "'])").css ({
          display: 'none',
        });
        jQuery (".ct-products[data-page='" + switchToPage + "']").css ({
          display: 'block',
        });
        currentPage = switchToPage;
      }
    }
  }
  //Allows removal of items from catalog.
  function setDeleteProductListener () {
    var handle;
    //Start of hover actions
    jQuery ('.ct-single-product').off ();
    jQuery ('.ct-single-product').on ('mouseenter touchstart', function () {
      clearTimeout (handle);
      jQuery (this).prepend (jQuery ('.ct-remove-product'));
      jQuery ('.ct-remove-product').css ('display', 'flex');
      handle = setTimeout (function () {
        jQuery ('.ct-remove-product').css ('opacity', '1');
      }, 20);
    });

    jQuery ('.ct-single-product').on ('mouseleave touchend', function () {
      clearTimeout (handle);
      jQuery (this).append (jQuery ('.ct-remove-product'));
      jQuery ('.ct-remove-product').css ('opacity', '0');
      jQuery ('.ct-remove-product').css ('display', 'none');
      jQuery ('.generate-catalog').append (jQuery ('.ct-remove-product'));
    });
    //End of hover actions

    jQuery ('.ct-remove-product').off ();
    jQuery ('.ct-remove-product').on ('click', function () {
      jQuery ('.ct-remove-product').css ({opacity: '0', display: 'none'});
      var currentPage = jQuery (this)
        .closest ('.ct-products')
        .attr ('data-page');

      let singleProduct = jQuery (this).closest ('.ct-single-product');
      //The remove overlay is in the single product to be deleted. Move it somehwere else before deleting the single prodcut
      jQuery ('.generate-catalog').append (jQuery ('.ct-remove-product'));
      singleProduct.remove ();
      //Clone all the single products and re-render them
      rearrangeImagesIntoPages (jQuery ('.ct-single-product'));

      addClearFixes ();
      //Remove the pagination and re-render it.
      jQuery ('.ct-n-page').remove ();
      var switchToPage= parseInt (currentPage);
      //If the last page has been removed, switch to second last page.
      if(jQuery ('.ct-products').length<(switchToPage+1)){
        switchToPage--;
      }
      generatePagination (switchToPage);
    });
  }
  //Adds clearfixes after each 4 items in a row.
  function addClearFixes () {
    jQuery ('.ct-products').each ((idx, page) => {
      var nProducts = jQuery (page).children ('.ct-single-product').length;
      var insertPos = 4;
      for (let i = 1; i <= nProducts; i++) {
        if (i === insertPos) {
          jQuery (page)
            .children ('div:nth-child(' + i + ')')
            .after ('<div class="clearfix"></div>');
          i++;
          insertPos = i + 4;
        }
      }
    });
  }

  //Adds clearfixes, generates pagination and hides loading screen when everything is loaded.
  function ctImageLoadListener () {
    addClearFixes ();
    generatePagination ();
    jQuery ('.ct-download').css ('display', 'block');
    jQuery ('.ct-upload').css ('display', 'block');

    currentCatalogScreen.css ({display: 'block'});
    setTimeout (function () {
      currentCatalogScreen.css ({opacity: '1'});
    }, 50);
    jQuery ('.catalog-back').css ({visibility: 'visible'});
    jQuery ('.sort-catalog img').css ('display', 'block');
    hideCtLoadingScreen ();
    setDeleteProductListener ();
  }

  function insertImagesIntoPages (tobeInserted) {
    var nPages = Math.ceil (tobeInserted.length / 16);
    var pages = [...Array (nPages)].map ((val, i) =>
      jQuery ('<div class="ct-products" data-page="' + i + '"></div>')
    );
    currentPage = 0;
    tobeInserted.each (function (idx, product) {
      pages[currentPage].append (product);
      if (idx + 1 >= (currentPage + 1) * 16) {
        currentPage++;
      }
    });
    jQuery ('.ct-products').remove ();
    pages.forEach (function (page) {
      jQuery ('.ct-footer-img').before (page);
    });
  }
  function rearrangeImagesIntoPages (tobeInserted) {
    jQuery(".ct-products .clearfix").remove();
    currentPage = 0;
    tobeInserted.each (function (idx, product) {
      jQuery('.ct-products[data-page="'+currentPage+'"]').append (product);
      if (idx + 1 >= (currentPage + 1) * 16) {
        currentPage++;
      }
    });
    if(jQuery ('.ct-preview>div:nth-last-child(2)').children('.ct-single-product').length<1){
      jQuery ('.ct-preview>div:nth-last-child(2)').remove();
    }
    jQuery ('.ct-products').each (function (idx,page) {
      jQuery ('.ct-footer-img').before (page);
    });
  }
  function generateCatalogForSearchCart () {
    var imageCount = 0;
    var ctPageCount = 0;
    var currentPage = jQuery ('.ct-products');
    var currentLimit = 16;
    selectedItems.forEach (handle => {
      if (imageCount >= currentLimit) {
        ctPageCount++;
        currentPage = jQuery (
          '<div class="ct-products" data-page="' + ctPageCount + '"></div>'
        );
        jQuery ('.ct-footer-img').before (currentPage);
        currentLimit = 16 + currentLimit;
      }
      if (ctPageCount > 0) {
        currentPage.css ('display', 'none');
      }
      imageCount += 1;
      let parentPage = currentPage;
      var product = savedItemsForGeneration[handle];
      var imgUrlArr = product.image
        ? product.image.split ('?')
        : product.featured_image.split ('?');

      var imgSize = product.variant_title && product.variant_title === 'Small'
        ? '210'
        : '280';

      //ImageArr contains url of the image, by appending _210x.jpg, for example, we can directly fetch image of that size from the server.
      var imgUrl =
        imgUrlArr[0].slice (0, -4) +
        '_' +
        imgSize +
        'x' +
        imgUrlArr[0].slice (-4) +
        (imgUrlArr[1] ? '?' + imgUrlArr[1] : '');

      //Start of Product title
      product.title = product.variant_title
        ? product.variant_title +
            ' | ' +
            product.title.replace (/\-\sSmall|-\sLarge|Large|Small/g, '')
        : product.title;

      product.title = product.quantity
        ? product.quantity + ' ' + product.title
        : product.title;

      //End of product title

      //Generate html for product
      var html =
        "<div class='ct-single-product col-sm-3 col-xs-3'><div class='ct-img-wrapper'><img src='" +
        imgUrl +
        "' style='width:" +
        imgSize * 0.5 +
        "px'> </img></div><p>" +
        product.title +
        '</p>';

      //Set notes.
      let note = product.properties &&
        product.properties['Notes for our Design Team']
        ? product.properties['Notes for our Design Team']
        : false;
      if (note) {
        html =
          html + "<p class='notes-for-team'> <b>Notes: </b>" + note + '</p>';

        /*  note = note.split(" ").map(word=>(word.slice(0,5)+"&shy;"+word.slice(5))).join(" ");
          html =  html
          + "<p class='notes-for-team'> <b>Notes: </b>" + note.slice(0,75).replace(/&[shy;]*$/,"")+"..."+ "</p>";
 */
      }

      html += '</div>';
      parentPage.append (jQuery (html));
    });
    setTimeout (function () {
      ctImageLoadListener ();
    }, 1000);
    //Add &shy; at appropriate places so that sentence don't spill out.
    pleaseBeShyWords (jQuery ('.notes-for-team'), 6, 1000, false);
  }

  function generateCatalogForCollections () {
    var imageCount = 0;
    var ctPageCount = 0;
    var currentPage = jQuery ('.ct-products');
    var currentLimit = 16;
    var imagesAdded = 0;
    var collectionsTobeLoaded = selectedItems.length;
    var collectionsLoaded = 0;
    var products = new Array ();
    if (collectionsTobeLoaded < 1) {
      hideCtLoadingScreen ();
    } else {
      selectedItems.forEach (handle => {
        var page = 1;

        getCollectionPages ();
        function getCollectionPages () {
          jQuery.getJSON (
            '/collections/' + handle + '/products.json?limit=1000&page=' + page,
            function (collection) {
              if (collection.products.length > 0) {
                products = [...products, ...collection.products];
                page++;
                getCollectionPages ();
              } else {
                collectionsLoaded++;
                page = 1;
              }
              if (collectionsLoaded >= collectionsTobeLoaded) {
                var imagesTobeLoaded = products.length;
                products.forEach (product => {
                  if (imageCount >= currentLimit) {
                    ctPageCount++;
                    currentPage = jQuery (
                      '<div class="ct-products" data-page="' +
                        ctPageCount +
                        '"></div>'
                    );
                    jQuery ('.ct-footer-img').before (currentPage);
                    currentLimit = 16 + currentLimit;
                  }
                  if (ctPageCount > 0) {
                    currentPage.css ('display', 'none');
                  }
                  imageCount += 1;
                  let parentPage = currentPage;
                  if(typeof(product.images[0])=="undefined")
                    imgUrl = "https://placehold.jp/34/3eadef/000000/400x400.png?text=Image%20Not%20Available&css=%7B%22border-radius%22%3A%221000px%22%2C%22margin%22%3A%220px%22%7D";
                  else{
                    var imgUrlArr = product.images[0].src.split ('?');
                    //ImageArr contains url of the image, by appending _210x.jpg, for example, we can directly fetch image of that size from the server.
                    var imgUrl =
                      imgUrlArr[0].slice (0, -4) +
                      '_400x' +
                      imgUrlArr[0].slice (-4) +
                      (imgUrlArr[1] ? '?' + imgUrlArr[1] : '');
                  }

                  //Generate html for product
                  var html =
                    "<div class='ct-single-product col-sm-3 col-xs-3'><img src='" +
                    imgUrl +
                    "'> </img><p>" +
                    product.title +
                    '</p></div>';

                  parentPage.append (jQuery (html));
                  imagesAdded++;
                  if (imagesAdded >= imagesTobeLoaded) {
                    setTimeout (function () {
                      ctImageLoadListener ();
                    }, 1500);
                  }
                });
              }
            }
          );
        }
      });
    }
  }

  jQuery ('.enter-ct-name').on ('input', function () {
    jQuery ('#catalog-name').html (jQuery (this).val ());
  });

  async function downloadCatalog () {
    /*   if (screen.width < 1024) {
      document
        .querySelector("meta[name='viewport']")
        .setAttribute("content", "width=1366");
      jQuery(window).trigger("resize");
    } */

    var canvasText = document.querySelectorAll (
      '.ct-single-product,.catalog-name'
    );

    for (let i = 0; i < canvasText.length; i++) {
      canvasText[i].style.fontFeatureSettings = '"liga" 0';
    }
    //8.5 by 11 inch doc size
    var doc = new jsPDF ('p', 'pt', [612, 792], true);

    var width = doc.internal.pageSize.getWidth ();
    var height = doc.internal.pageSize.getHeight ();
    var nPages = document.querySelectorAll ('.ct-products').length;
    if (nPages < 1) {
      return;
    }
    showCtLoadingScreen ('Generating Catalog (page 1/' + nPages + ')');

    var imageForThumbnail;
    for (let idx = 0; idx < nPages; idx++) {
      jQuery ('.ct-products').css ('display', 'none');
      jQuery (".ct-products[data-page='" + idx + "']").css ('display', 'block');
      await new Promise ((resolve, reject) => {
        html2canvas (jQuery ('.ct-preview')[0], {
          allowTaint: true,
          removeContainer: true,
          backgroundColor: null,
          imageTimeout: 15000,
          logging: false,
          scale: screen.width < 768 ? 4 : 2,
          useCORS: true,
          letterRendering: true,
          scrollY: 0,
        }).then (function (canvas) {
          var imgData = canvas.toDataURL ('image/png');
          if (idx === 0) {
            imageForThumbnail = imgData;
          }
          //Add images to the doc object
          doc.addImage (
            imgData,
            'PNG',
            -2,
            -1,
            width + 2,
            height + 2,
            undefined,
            'FAST'
          );
          //Adjust loading screen if there are more pages left to be added to doc object.
          if (idx + 1 < nPages) {
            doc.addPage ();
            showCtLoadingScreen (
              'Generating Catalog (page ' + (idx + 2) + '/' + nPages + ')'
            );
          } else {
            //Catalog name
            var fSuffix = jQuery ('#catalog-name')
              .html ()
              .trim ();
            fSuffix = fSuffix.length > 0 ? fSuffix : 'catalog';
            doc.save (fSuffix + '.pdf');
            hideCtLoadingScreen ();
            // uploadCatalog (
            //   doc,
            //   imageForThumbnail,
            //   jQuery ('#catalog-name').html ().trim ()
            // );
            //Switch to the first page.
            jQuery ('.ct-products').css ('display', 'none');
            jQuery (".ct-products[data-page='0']").css ('display', 'block');
            // Switch to the first pagination
            jQuery ('.ct-pagination a:nth-child(2)').trigger ('click');

              
          }
          resolve (true);
        });
      });
    }
  }
  jQuery ('.ct-download').click (function () {

    downloadCatalog ();
  });



  jQuery ('.sort-catalog img').click (function (event) {
    event.stopPropagation ();
    jQuery ('.sort-catalog .dropdown-container').css ('display', 'block');

    setTimeout (function () {
      jQuery ('.sort-catalog .dropdown-container').css ('opacity', '1');
    }, 50);
  });

  jQuery ('#sort-catalog-descending').click (function () {
    var sorted = jQuery ('.ct-single-product')
      .sort (function (a, b) {
        //Get image title, remove the style number and qty suffix.
        var aTitle = jQuery (a)
          .children ('p')
          .html ()
          .split (/[\s,-]+/)
//           .slice (1)
          .join ('');
        var bTitle = jQuery (b)
          .children ('p')
          .html ()
          .split (/[\s,-]+/)
//           .slice (1)
          .join ('');
        
        aTitle = parseInt(aTitle);
        bTitle = parseInt(bTitle);

        //Sorting rule
        if (aTitle < bTitle) {
          return 1;
        }
        if (aTitle > bTitle) {
          return -1;
        }
        return 0;
      })
      .clone ();

    jQuery ('.ct-single-product').each (function (idx, nodeObject) {
      jQuery (nodeObject).replaceWith (sorted[idx]);
    });
    setDeleteProductListener ();
  });

  jQuery ('#sort-catalog-ascending').click (function () {
    var sorted = jQuery ('.ct-single-product')
      .sort (function (a, b) {
        //Get image title, remove the style number and qty suffix.
        var aTitle = jQuery (a)
          .children ('p')
          .html ()
          .split (/[\s,-]+/)
//           .slice (1)
          .join ('');
        var bTitle = jQuery (b)
          .children ('p')
          .html ()
          .split (/[\s,-]+/)
//           .slice (1)
          .join ('');
        
        aTitle = parseInt(aTitle);
        bTitle = parseInt(bTitle);

        //Sorting rule
        if (aTitle < bTitle) {
          return -1;
        }
        if (aTitle > bTitle) {
          return 1;
        }
        return 0;
      })
      .clone ();
    jQuery ('.ct-single-product').each (function (idx, nodeObject) {
      jQuery (nodeObject).replaceWith (sorted[idx]);
    });
    setDeleteProductListener ();
  });

  jQuery ('#sort-catalog-random').click (function () {
    var sorted = jQuery ('.ct-single-product')
      .sort (function (a, b) {
        //Sorting rule
        return Math.random () < 0.5 ? 1 : -1;
      })
      .clone ();
    jQuery ('.ct-single-product').each (function (idx, nodeObject) {
      jQuery (nodeObject).replaceWith (sorted[idx]);
    });
    setDeleteProductListener ();
  });

  /**----------------------------------------------------------------------------- */
  //Works on /cart page to generate catalog from cart items in a single click.
  jQuery ('.create_cart_catalog').click (function (evt) {
    evt.preventDefault ();
    evt.stopPropagation ();
    jQuery ('.select-catalog').css ('display', 'none');
    jQuery ('.catalog-back').css ({visibility: 'hidden'});
    jQuery ('#download-catalog')[0].click ();
    jQuery ('.catalog-next').css ('display', 'none');
    currentCatalogSelection = jQuery ("[data-option='cart']");
    currentCatalogScreen = jQuery ('.generate-catalog');
    showCtLoadingScreen ();

    jQuery.getJSON ('/cart.json?limit=100').then (response => {
      selectedItems = response.items.map (item => {
        savedItemsForGeneration[item.key] = item;
        return item.key;
      });
      generateCatalogForSearchCart ();
      currentCatalogScreen.css ({display: 'block'});
    });
    return;
  });

  /**----------------------------------------------------------------------------- */
  //Upload files on Stickerpack app server.

  const uploadCatalog = async function (doc, imageForThumbnail, catalogName) {
    var blob = doc.output ('blob');
    showCtLoadingScreen ('Saving catalog...');
    var catalogState = {
      type: currentCatalogSelection.attr ('data-option'),
      selectedItems: selectedItems,
      savedItemsForGeneration: savedItemsForGeneration,
      catalogName:catalogName,
    };
    if ('collection' === catalogState.type || 'search' === catalogState.type) {
      catalogState.searchQueryTerm = searchQueryTerm;
    }
    var formData = new FormData ();

    formData.append ('file', blob);
    formData.append (
      'imageForThumbnail',
      await downscaleImage (imageForThumbnail, 300, 'image/png', 0.8)
    );
    formData.append ('customerId', window.customerId);
    formData.append ('catalogName', catalogName);
    formData.append ('catalogState', JSON.stringify (catalogState));

    fetch ('/apps/stickerpack-custom/api/upload-catalog', {
      method: 'POST',
      body: formData,
    }).then (() => {
      if(editModeCatalogName && editModeCatalogName!==catalogName){
        deleteCatalog(editModeCatalogName,hideCtLoadingScreen);
        editModeCatalogName=catalogName;

      }else{
        hideCtLoadingScreen ();
      }
    });
  };


  /**
   * Compresses thumnail before uploading
   */

  // Take an image URL, downscale it to the given width, and return a new image URL.
  async function downscaleImage (dataUrl, newWidth, imageType, quality) {
    var image, oldWidth, oldHeight, newHeight, canvas, ctx, newDataUrl;

    // Provide default values
    imageType = imageType || 'image/png';
    quality = quality || 0.7;

    // Create a temporary image so that we can compute the height of the downscaled image.
    image = new Image ();
    image.src = dataUrl;
    newDataUrl = await new Promise (resolve => {
      image.onload = function () {
        oldWidth = image.width;
        oldHeight = image.height;
        newHeight = Math.floor (oldHeight / oldWidth * newWidth);

        // Create a temporary canvas to draw the downscaled image on.
        canvas = document.createElement ('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;

        // Draw the downscaled image on the canvas and return the new data URL.
        ctx = canvas.getContext ('2d');
        ctx.drawImage (image, 0, 0, newWidth, newHeight);
        newDataUrl = canvas.toDataURL (imageType, quality);
        resolve (newDataUrl);
      };
    });

    return newDataUrl;
  }

  /**------------------------------------------------------------------------------------------------ */
  /**
   * Loads items on saved-catalogs page.
   */

  function fetchSavedCatalogs (renderCallback) {
    fetch (
      '/apps/stickerpack-custom/api/get-catalogs?customerId=' +
        window.customerId
    )
      .then (response => response.json ())
      .then (result => {
        var catalogFiles = {};

        result['files'].forEach (file => {
          var keyParts = file.split('/');
          var catalogName = keyParts[keyParts.length-1].split('__')[0];
          if (!catalogFiles[catalogName]) {
            catalogFiles[catalogName] = {
              pdf: STICKERPACK_APP_BUCKET+'/saved-catalogs/' +
                window.customerId +
                '/' +
                catalogName +
                '__catalog.pdf',
              thumbnail: STICKERPACK_APP_BUCKET+'/saved-catalogs/' +
                window.customerId +
                '/' +
                catalogName +
                '__thumbnail.png',
              catalogState: STICKERPACK_APP_BUCKET+'/saved-catalogs/' +
                window.customerId +
                '/' +
                catalogName +
                '__state.json',
            };
          }
        });
        if(result['files'].length)
          document.getElementById("deleteAllCatalogs").style.display = "";
        renderCallback (catalogFiles);
      });
  } 

  if(window.fetchSavedCatalogs===true){
    fetchSavedCatalogs (renderCatalogs);
  }

  function renderCatalogs (catalogFiles) {
    for (catalogName in catalogFiles) {
      var html =
        '<div class="catalog-item-wrapper col-xs-12 margin-top-50 padding-0 padding-top-20">\
       <div class="col-sm-4 col-md-5 col-xs-12 alpha text-center">\
       <h4 class="text-center d-sm-hidden margin-bottom-20">' +
        catalogName +
        '</h4>\
       <img src="' +
        catalogFiles[catalogName].thumbnail +
        '" alt="' +
        catalogName +
        '" class="lazyload lazyload--fade-in"/>\
       </div>\
       <div class="col-sm-8 col-md-7 col-xs-12 omega padding-0"><h4 class="text-center d-sm-block">' +
        catalogName +
        '</h4>\
         <div class="download-item col-sm-12 col-xs-12 margin-top-20">\
         <a href="' +
        catalogFiles[catalogName].pdf +
        '" target="_blank">\
           <button class="action_button">Download<img src="//stickerpack.com/cdn/shop/t/47/assets/download_icon-blue.svg?v=57303041209379310461786139810" alt="" >\
           <img src="//stickerpack.com/cdn/shop/t/47/assets/download_icon.svg?v=90581660645581313951786139810" alt="" />\
           </button>\
         </a>\
         </div>\
         <div class="edit-item col-sm-12 col-xs-12 margin-top-20">\
          <button class="action_button edit-catalog" data-ct-state-url="' +
        catalogFiles[catalogName].catalogState +
        '"data-ct-name="'+catalogName+'">Edit<img src="//stickerpack.com/cdn/shop/t/47/assets/edit-blue.svg?v=71624530181524259541786139810" alt="" >\
          <img src="//stickerpack.com/cdn/shop/t/47/assets/edit.svg?v=2216937943307798681786139810" alt="" />\
          </button>\
         </div>\
         <div class="delete-item col-sm-12 col-xs-12 margin-top-20">\
          <button class="action_button delete-catalog" data-ct-name="' +
          catalogName+
        '"><span>Delete</span><img src="//stickerpack.com/cdn/shop/t/47/assets/trash-blue.svg?v=102909762917582988841786139810" alt="" >\
          <img src="//stickerpack.com/cdn/shop/t/47/assets/trash.svg?v=152302923644996893061786139810" alt="" />\
          <span class="btn-spinner"><img src="//stickerpack.com/cdn/shop/t/47/assets/loader-sm-blue.svg?v=22175832533664557731786139810" alt="" /><img src="//stickerpack.com/cdn/shop/t/47/assets/loader-sm.svg?v=28076881541690525881786139810" alt="" /></span>\
          </button>\
          </div>\
       </div>\
       <br class="clear"/>\
       <br class="clear"/>\
     </div>';

      $ ('#saved-catalogs .catalogs_items').append ($ (html));
    }
  }


  /**
   * Edit a catalog on saved-catalogs page.
   */

  jQuery ('body').on ('click', '.edit-catalog', function () {
    var stateUrl = jQuery (this).data ('ct-state-url');
    editModeCatalogName = jQuery (this).data ('ct-name');

    jQuery ('#main-catalog-wrapper').css ({display: 'block'});
    jQuery ('.catalog-next').parent ().addClass ('adjustNextButton');
    jQuery ('#mm-blocker').trigger ('mousedown');
    jQuery ('#main-catalog-wrapper').css ({opacity: '1'});
    jQuery ('html').css ({overflow: 'hidden'});
    jQuery ('.select-catalog').css ({display: 'none'});

    showCtLoadingScreen ();

    jQuery.getJSON (stateUrl, function (data) {
      var catalogState = data;
      currentCatalogScreen = jQuery (
        "[data-screen='" + catalogState.type + "'"
      );
      currentCatalogSelection = jQuery (
        ".single-option[data-option='" + catalogState.type + "']"
      );

      selectedItems = catalogState.selectedItems;
      jQuery ('.enter-ct-name').val (catalogState.catalogName).trigger('input');

      if ('search'===catalogState.type) {
        jQuery ('.predictive-search-select').val (catalogState.searchQueryTerm);
        currentCatalogScreen.css ({display: 'block'});
        changeToNextScreen ();
      } else if ('collection' === catalogState.type) {
        jQuery ('.collection-multiple-select').select2 ('val', selectedItems);
        currentCatalogScreen.css ({display: 'block'});
        changeToNextScreen ();
      } else if ('cart' === catalogState.type) {
        jQuery ('.catalog-next').css ('display', 'none');
        currentCatalogScreen = jQuery ('.generate-catalog');
        currentCatalogScreen.css ({display: 'block'});
        savedItemsForGeneration = catalogState.savedItemsForGeneration;
        generateCatalogForSearchCart ();
      }
    });
  });

  jQuery ('body').on ('click', '.delete-catalog', function () {
    var catalogName = jQuery(this).data('ct-name');
    var catalogRef = jQuery(this).closest('.catalog-item-wrapper');
    var ref=jQuery(this);
    jQuery(this).children("span:first-child,img").css("display", "none");
    jQuery(this).children(".btn-spinner").css("display", "block");
    deleteCatalog(catalogName,function(){
      catalogRef.remove();
      ref.children("span:first-child,img").css("display", "block");
      ref.children(".btn-spinner").css("display", "none");
    });
  });
  const deleteAllCatalogs = async function () {
    fetch (
      '/apps/stickerpack-custom/api/delete-catalogs?customerId='+window.customerId
    ).then(
      response => response.json()
    ).then (result => {
      location.reload();
    });
  };
  jQuery ('body').on ('click', '#deleteAllCatalogs', function () {
    jQuery ('#download-catalog')[0].click ();
    showCtLoadingScreen ('Deleting catalogs...');
    deleteAllCatalogs();
  });


  function deleteCatalog(catalogName,onSuccess){
    var deleteCatalogUrl = '/apps/stickerpack-custom/api/delete-catalog';
    jQuery
    .ajax({ 
      url: deleteCatalogUrl,
      type: "POST",
      data: {
        catalogName: catalogName,
        customerId:window.customerId,
      },
      dataType: "json",
    })
    .done(function (response) {
      if('success'===response.message) {
        onSuccess();
      }else{
        console.log(response);
      }

    });
  }


    //Debounce function.
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }


    //Catalog search
  $(".search-saved-catalog").on(
    "input",
    debounce(function () {
      $(".catalogs_items").children().each((idx,item)=>{
          var title=$(item).find(".omega h4").html();
          if(!title){
            return;
          }
          var searchVal=$('.search-saved-catalog').val().toLowerCase();
          if(title.trim(" ").toLowerCase().search(searchVal)>=0){
            $(item).css('display','block');
          }else{
            $(item).css('display','none');
          }
      });
    }, 300)
  );
});